import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, switchMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { SparePartsActions } from './spare-parts.actions';
import { SparePartService } from '../../services/spare-part.service';

@Injectable()
export class SparePartsEffects {
  private actions$ = inject(Actions);
  private svc = inject(SparePartService);

  loadSpareParts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SparePartsActions.loadSpareParts),
      mergeMap(() => this.svc.getAll().pipe(
        map(spareParts => SparePartsActions.loadSparePartsSuccess({ spareParts })),
        catchError(err => of(SparePartsActions.loadSparePartsFailure({ error: err.message })))
      ))
    )
  );

  createSparePart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SparePartsActions.createSparePart),
      mergeMap(({ dto }) => this.svc.create(dto).pipe(
        map(sparePart => SparePartsActions.createSparePartSuccess({ sparePart })),
        catchError(err => of(SparePartsActions.createSparePartFailure({ error: err.message })))
      ))
    )
  );

  updateSparePart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SparePartsActions.updateSparePart),
      mergeMap(({ id, dto }) => this.svc.update(id, dto).pipe(
        map(sparePart => SparePartsActions.updateSparePartSuccess({ sparePart })),
        catchError(err => of(SparePartsActions.updateSparePartFailure({ error: err.message })))
      ))
    )
  );

  deleteSparePart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SparePartsActions.deleteSparePart),
      mergeMap(({ id }) => this.svc.delete(id).pipe(
        map(() => SparePartsActions.deleteSparePartSuccess({ id })),
        catchError(err => of(SparePartsActions.deleteSparePartFailure({ error: err.message })))
      ))
    )
  );

  loadMovements$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SparePartsActions.loadMovements),
      switchMap(({ sparePartId }) => this.svc.getMovements(sparePartId).pipe(
        map(movements => SparePartsActions.loadMovementsSuccess({ sparePartId, movements })),
        catchError(err => of(SparePartsActions.loadMovementsFailure({ error: err.message })))
      ))
    )
  );

  purchaseStock$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SparePartsActions.purchaseStock),
      mergeMap(({ dto }) => this.svc.purchase(dto).pipe(
        map(movement => SparePartsActions.purchaseStockSuccess({ movement })),
        catchError(err => of(SparePartsActions.purchaseStockFailure({ error: err.message })))
      ))
    )
  );

  adjustStock$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SparePartsActions.adjustStock),
      mergeMap(({ dto }) => this.svc.adjust(dto).pipe(
        map(movement => SparePartsActions.adjustStockSuccess({ movement })),
        catchError(err => of(SparePartsActions.adjustStockFailure({ error: err.message })))
      ))
    )
  );
}
